module.exports = __webpack_public_path__ + "img/classroom-03012025.0e65b3c5.jpg";